import React, { useEffect, useState } from "react";
import RouterOutlet from "../../Routes";
import classes from "./Wizard.module.css";
import { withRouter } from "react-router-dom";
import { useAppContext, ContextConstants } from "../../Context/AppContext";
import Loader from "../Shared/Loader/Loader";
import a from "../RFQ/assets/images/1.gif";
import { Constants } from "../../Constants";
import { CircularProgress } from "../Shared/CircularProgress/CircularProgress";
import ActiveProcurementList from "./ActiveProcurementList";
import useFetchRfqs from "../../hooks/useFetchRfqs";
import {
  checkRoute,
  closeModalMenu,
  handleSideBarToggle,
  isGeneralInfoValid,
  NavLink,
  onSave,
  registerTransporterWithMixpanel,
} from "./utility";
import PopupWidget from "../PopupWidget";
import { useTransporterData } from "../../hooks/useTransporterData";
import { useMixPanelForTracking } from "../../shared_utilities/trackMixPanel";
import OnboardingGate from "../Onboarding";

/** Returns true when the fetched profile has no transporter_name — i.e. brand-new account */
const isNewTransporter = (data) => !data?.transporter_name;

const Wizard = ({ history }) => {
  const { TrackMixPanel } = useMixPanelForTracking();
  const [showDhandaNow, setShowDhandaNow] = useState(false);
  const [showLocationDashboard, setShowLocationDashboard] = useState(false);
  const {
    dispatch,
    validate,
    transporterInfo,
    clientIp,
    isEditable,
  } = useAppContext();
  const [profileShow, setProfileShow] = useState(true);
  const [tenderShow, setTenderShow] = useState(true);
  const [indentShow, setIndentShow] = useState(false);
  const [companyShow, setCompanyShow] = useState(false);

  const [landingPage, setLandingPage] = useState("");

  const {
    data: transporterData,
    isLoading,
    refetch,
  } = useTransporterData(dispatch);

  useEffect(() => {
    if (transporterData) {
      // New transporter — onboarding flow handles their setup, skip normal wizard init
      if (isNewTransporter(transporterData)) return;

      registerTransporterWithMixpanel(
        transporterData,
        transporterData?.user_details?.contact_number,
        clientIp
      );
      if (!isGeneralInfoValid(transporterData)) {
        dispatch({ type: ContextConstants.ToggleEdit });
      }

      const policies = transporterData.policy || {};
      setShowDhandaNow(policies.dhandhanow?.allowed === "yes");
      setShowLocationDashboard(policies.location_dashboard?.allowed === "yes");
      let currUser = {};
      if (transporterData?.access_control?.length > 0) {
        currUser = transporterData?.access_control?.find(
          (i) => i?.contact_number === transporterData?.user_details?.contact_number
        );
      }
      if (currUser && Object.keys(currUser)?.length > 0 && currUser?.landing_page?.value) {
        setLandingPage(currUser?.landing_page?.value);
      } else if (policies?.landing_page && policies?.landing_page !== "") {
        setLandingPage(policies?.landing_page);
      } else {
        setLandingPage(Constants.RoutePaths.GeneralInformation);
      }
    }
  }, [transporterData, clientIp]);

  const setNavigatingAway = (state) => {
    dispatch({
      type: ContextConstants.NavigatingAway,
      payload: state,
    });
  };

  const ActiveClicked = () => {
    TrackMixPanel({
      ModuleName: "tpmp procurements",
      ScreenName: "active tenders",
      Data: "none",
      Definition: "user has clicked on the active tenders tab.",
    });
    if (checkRoute("/activeprocurement", isEditable)) {
      history.push({
        pathname: "/activeprocurement",
      });
    }
  };

  const ClosedClicked = () => {
    if (checkRoute("/closedprocurement", isEditable)) {
      TrackMixPanel({
        ModuleName: "tpmp procurements",
        ScreenName: "closed tenders",
        Data: "none",
        Definition: "user has clicked on the closed tenders tab.",
      });
      history.push({
        pathname: "/closedprocurement",
      });
    }
  };

  const onNavClick = (path) => {
    let isValid = true;

    if (isEditable) {
      const { pathname } = history.location;

      const validationMap = {
        [Constants.RoutePaths.GeneralInformation]: validate.GeneralInfo,
        [Constants.RoutePaths.BusinessProfile]: validate.BusinessProfile,
        [Constants.RoutePaths.OperationsOverview]: validate.OperationsOverview,
        [Constants.RoutePaths.CustomerDetails]: validate.CustomerDetails,
        [Constants.RoutePaths.ContractClosureInfo]: validate.Contract,
      };

      const validator = validationMap[pathname];
      if (validator) {
        isValid = validator(transporterInfo);
      }

      setNavigatingAway(!isValid);
    }

    if (window.innerWidth < 600) {
      closeModalMenu();
    }

    if (!isValid) {
      alert("Please resolve validation error(s)");
      return;
    }

    if (!checkRoute(path, isEditable)) return;

    TrackMixPanel({
      ModuleName: "navigation",
      ScreenName: path.toLowerCase(),
      Data: "none",
      Definition: `user has navigated to ${path}`
    });

    if (isEditable) {
      onSave(
        transporterInfo,
        dispatch,
        () => {
          history.push({ pathname: path });
        },
        refetch
      );
    } else {
      history.push({ pathname: path });
    }
  };

  const isProfilePage =
    window.location.pathname.includes("profile") ||
    window.location.pathname.includes("MyProfile");

  const shouldShowNavigation =
    !isProfilePage && transporterInfo.account_type !== "blocked";

  // ── New transporter: show onboarding flow, hide sidebar entirely ──
  if (transporterData && isNewTransporter(transporterData)) {
    return (
      <div className={classes.container}>
        <OnboardingGate
          transporterData={transporterData}
          history={history}
          refetch={refetch}
        />
        <Loader show={isLoading} />
      </div>
    );
  }

  return (
    <div className={classes.container}>
      {transporterInfo.account_type !== "blocked" && (
        <button
          className={`${classes["WizardMenuHideButton"]} btn btn-sm btn-dark`}
          onClick={handleSideBarToggle}
        >
          <i className="far fa-eye"></i>
        </button>
      )}

      {shouldShowNavigation && (
        <>
          <div id="sidebar" className={`hide_on_mobile ${classes.nav_container}`}>
            <NavigationMenu
              history={history}
              onNavClick={onNavClick}
              transporterInfo={transporterInfo}
              ActiveClicked={ActiveClicked}
              ClosedClicked={ClosedClicked}
              profileShow={profileShow}
              setProfileShow={setProfileShow}
              tenderShow={tenderShow}
              setTenderShow={setTenderShow}
              companyShow={companyShow}
              setCompanyShow={setCompanyShow}
              indentShow={indentShow}
              setIndentShow={setIndentShow}
              showDhandaNow={showDhandaNow}
              showLocationDashboard={showLocationDashboard}
            />
          </div>

          <PopupWidget
            buttonLabel="---"
            buttonclassName={`btn btn-sm btn-primary show_only_on_mobile ${classes.mobilePopupButton}`}
            content={
              <NavigationMenu
                history={history}
                onNavClick={onNavClick}
                transporterInfo={transporterInfo}
                ActiveClicked={ActiveClicked}
                ClosedClicked={ClosedClicked}
                profileShow={profileShow}
                setProfileShow={setProfileShow}
                tenderShow={tenderShow}
                setTenderShow={setTenderShow}
                companyShow={companyShow}
                setCompanyShow={setCompanyShow}
                indentShow={indentShow}
                setIndentShow={setIndentShow}
                showDhandaNow={showDhandaNow}
                showLocationDashboard={showLocationDashboard}
              />
            }
          />
        </>
      )}

      {transporterInfo.account_type === "blocked" ? (
        <div
          style={{
            marginTop: "16%",
          }}
          className="text-center w-100 font-weight-bold"
        >
          <span
            style={{
              border: "1px solid #393185",
              padding: "4%",
              color: "#393185",
              fontSize: "20px",
            }}
          >
            This profile is been blocked, Please email (lorri@logisticsnow.in)
            or call +91-8928008311 / +91-9867773519.
          </span>
        </div>
      ) : (
        <div id="wizard-body" className={classes["wiz-body"]}>
          <RouterOutlet policyLandingPage={landingPage} />
        </div>
      )}

      <Loader show={isLoading} />
    </div>
  );
};

const NavigationMenu = ({
  history,
  onNavClick,
  transporterInfo,
  ActiveClicked,
  ClosedClicked,
  profileShow,
  setProfileShow,
  tenderShow,
  setTenderShow,
  companyShow,
  setCompanyShow,
  indentShow,
  setIndentShow,
  showDhandaNow,
  showLocationDashboard,
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const { procurements } = useFetchRfqs("active");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderNavLink = (id, path, label, onClick = onNavClick) => (
    <NavLink
      id={id}
      history={history}
      onNavClick={onClick}
      path={path}
      title={
        <span style={{ fontSize: "16px", color: "var(--theme-color)" }}>
          {label}
        </span>
      }
      key={id}
    />
  );

  const renderToggleHeader = (label, state, setState, icon = null) => (
    <div
      onClick={() => setState(!state)}
      className={`px-3 py-2 border-bottom border-top ${classes.sectionCollapsibleHeader}`}
    >
      <span className={`p-1 pr-3`}>
        <i className={`fa fa-angle-${state ? "down" : "right"}`}></i>
      </span>
      <div className="d-flex justify-content-between w-100 position-relative">
        <span className={`text-dark font-weight-bold`}>{label}</span>
        {icon && (
          <span className="position-absolute" style={{ right: "-25px", top: "-5px" }}>
            {icon}
          </span>
        )}
      </div>
    </div>
  );

  return (
    <div className={``}>
      <div className={classes["main-div"]}>
        {/* LoRRI Profile */}
        <div className={classes.s_header}>
          {renderToggleHeader(
            "LoRRI Profile",
            profileShow,
            setProfileShow,
            <CircularProgress
              percent={transporterInfo?.percentage_completion}
              size={"40"}
              stroke={"3.2"}
              positionStyles={{ right: "19px", top: "-3px" }}
              title={"Profile Completion Percentage"}
            />
          )}

          {profileShow && (
            <nav className={`d-flex flex-column px-3 pb-3 pt-2 bg-light`}>
              {renderNavLink(
                "GeneralInformation",
                "/generalInfo",
                "General Information"
              )}
              {renderNavLink(
                "BusinessProfile",
                "/businessProfile",
                "Business Profile"
              )}
              {renderNavLink(
                "OperationsOverview",
                "/operationsOverview",
                "Operations Overview"
              )}
              {renderNavLink(
                "CustomerDetails",
                "/customerDetails",
                "Customer Details"
              )}
              {renderNavLink(
                "ContractClosureInfo",
                "/contract",
                "Contract Closure Info"
              )}
              {renderNavLink("PreviewProfile", "/MyProfile", "Preview Profile")}
              {renderNavLink("Dashboard", "/dashboard", "Dashboard")}
            </nav>
          )}
        </div>

        {/* Live Tenders / RFQ */}
        <div className={classes.s_header}>
          {renderToggleHeader(
            "Live Tenders/RFQ",
            tenderShow,
            setTenderShow,
            procurements.length > 0 && (
              <img
                alt="icon"
                className={classes["new-icon"]}
                src={a}
                width="35px"
              />
            )
          )}
          {tenderShow && (
            <nav className={`d-flex flex-column px-3 pb-3 pt-2 bg-light`}>
              {renderNavLink(
                "activeprocurement",
                "/activeprocurement",
                "Active Tenders",
                ActiveClicked
              )}
              <div className="" style={{ paddingLeft: "12px" }}>
                <ActiveProcurementList />
              </div>

              {renderNavLink("Auction", "/auction", "Auction")}
              {renderNavLink(
                "closedprocurement",
                "/closedprocurement",
                "Closed Tenders",
                ClosedClicked
              )}
            </nav>
          )}
        </div>

        {/* Get New Business */}
        <div className={`${classes.s_header}`}>
          {renderToggleHeader("Get New Business", companyShow, setCompanyShow)}
          {companyShow && (
            <nav className={`d-flex flex-column px-3 pb-3 pt-2 bg-light`}>
              {showDhandaNow &&
                renderNavLink("DhandhaNow", "/LaneIntelligence", "Lane Intelligence")}
              {showLocationDashboard &&
                renderNavLink(
                  "LocationDashboard",
                  "/LocationIntelligence",
                  "Location Intelligence"
                )}
              {renderNavLink("Company_Enquiries", "/trucks", "LoRRI Enquiries")}
            </nav>
          )}
        </div>

        {/* Indents */}
        <div className={classes.s_header}>
          {renderToggleHeader("Indents", indentShow, setIndentShow)}
          {indentShow && (
            <nav
              style={{ paddingLeft: "11%" }}
              className={`d-flex flex-column px-3 pb-3 pt-2 bg-light`}
            >
              {renderNavLink("indent_requests", "/indents/requests", "Indents")}
              {renderNavLink("lorri_invoice", "/indents/invoice", "Invoice")}
            </nav>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Wizard);
